 export function OnScroll($timeout) {
  'use strict';

  return {
    scope: {
      onScroll: '&onScroll',
      scrollDelay: '=',
    },
    link: function(scope,  element) {
      if (scope.scrollDelay === undefined) scope.scrollDelay = 250;
      let scrollThrottleTimeout;
      let throttled = false;
      const scrollHandler = (e) => {

        if (!throttled && element[0] === e.target) {
          scope.onScroll(e);
          throttled = true;
          scrollThrottleTimeout = $timeout(function() {
            throttled = false;
          }, scope.scrollDelay);
        }
      };

      element.on('scroll', scrollHandler);

      scope.$on('$destroy', function() {
        element.off('scroll', scrollHandler);
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/view/chat-viewer/on-scroll.component.js